module.exports = __webpack_public_path__ + "static/media/tvz900-compressor.44a1b45c.jpg";